export const VERSION_APP = '1.0.1';
export const HOME_DIR = '/';
export const ENV = {
    LOCAL: {
        API_BASE_URL: 'https://script.google.com/macros/s/AKfycbwMg8XcYvVMN_Ie0y4K30VVZq1kj4cq8AxUSfN5nqCPI3_3H1gsCXM6E8V6D18Wb_U5eQ/exec',
        LIFF_ID: '2006711844-2GZrmA3A'
    },
    PROD: {
        API_BASE_URL: 'https://script.google.com/macros/s/AKfycbwMg8XcYvVMN_Ie0y4K30VVZq1kj4cq8AxUSfN5nqCPI3_3H1gsCXM6E8V6D18Wb_U5eQ/exec',
        LIFF_ID: '2005468534-MmVWLdeb'
    }
}

export const CURRENT_ENV = ENV.PROD;
